import * as i0 from '@angular/core';
import { Directive, Pipe, NgModule } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import * as IBAN from 'iban';

class ValidatorService {
    static validateIban(c) {
        if (c.value && !IBAN.isValid(c.value)) {
            return { iban: { value: c.value } };
        }
        return null;
    }
}

class IbanValidatorDirective {
    validate(c) {
        return ValidatorService.validateIban(c);
    }
}
IbanValidatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: IbanValidatorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IbanValidatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.1", type: IbanValidatorDirective, selector: "[ibanValidator]", providers: [{ provide: NG_VALIDATORS, useExisting: IbanValidatorDirective, multi: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: IbanValidatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ibanValidator]',
                    providers: [{ provide: NG_VALIDATORS, useExisting: IbanValidatorDirective, multi: true }]
                }]
        }] });

class IbanFormatterPipe {
    transform(value, args) {
        if (IBAN.isValid(value)) {
            return IBAN.printFormat(value, ' ');
        }
        return value;
    }
}
IbanFormatterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: IbanFormatterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
IbanFormatterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.1", ngImport: i0, type: IbanFormatterPipe, name: "ibanFormatter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: IbanFormatterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ibanFormatter'
                }]
        }] });

class AngularIbanModule {
}
AngularIbanModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: AngularIbanModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AngularIbanModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.1", ngImport: i0, type: AngularIbanModule, declarations: [IbanValidatorDirective,
        IbanFormatterPipe], exports: [IbanValidatorDirective,
        IbanFormatterPipe] });
AngularIbanModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: AngularIbanModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: AngularIbanModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        IbanValidatorDirective,
                        IbanFormatterPipe
                    ],
                    imports: [],
                    exports: [
                        IbanValidatorDirective,
                        IbanFormatterPipe,
                    ]
                }]
        }] });

/*
 * Public API Surface of angular-iban
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularIbanModule, IbanFormatterPipe, IbanValidatorDirective, ValidatorService };
//# sourceMappingURL=angular-iban.mjs.map
